import { useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Seo } from "../components/Seo";
import { PageHeader } from "../components/PageHeader";
import { Portfolio } from "../components/Portfolio";
import { buildWebPage } from "../components/schema";

export default function RealizzazioniPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div data-testid="realizzazioni-page">
      <Seo
        title="Realizzazioni vetrate panoramiche VEPA | Portfolio VETRO DESIGN ITALIA"
        description="Realizzazioni di vetrate panoramiche VEPA: terrazzi, balconi e dehor. Portfolio dei progetti VETRO DESIGN ITALIA ad Ancona, Osimo e in tutte le Marche."
        path="/realizzazioni-vetrate-panoramiche"
        jsonLd={buildWebPage("Realizzazioni · VETRO DESIGN ITALIA", "/realizzazioni-vetrate-panoramiche", "Portfolio delle realizzazioni di vetrate panoramiche VEPA di VETRO DESIGN ITALIA nelle Marche.", "Realizzazioni")}
      />
      <Navbar />
      <PageHeader
        eyebrow="Realizzazioni"
        h1="Progetti realizzati: vetrate panoramiche su misura"
        intro="Una selezione delle nostre installazioni di vetrate panoramiche VEPA in contesti residenziali e professionali nelle Marche."
      />
      <Portfolio />
      <Footer />
    </div>
  );
}
